import React, { useEffect } from 'react';
import { document_sign_url } from '../../common/constants/allowed_iframe_urls';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import styles from '../library-item-details/LibraryItemDetails.module.scss';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDocumensoRedirect } from '../../common/hooks/useDocumensoRedirect';

const SigningPage = () => {
  const { documentId } = useParams();
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const view = params.get('view');
  const backUrl = params.get('backUrl');
  const activeTab = params.get('activeTab');
  const { redirectToDocumenso, isLoading, error } = useDocumensoRedirect();

  const destinationPath = document_sign_url(String(documentId), view === 'true');

  useEffect(() => {
    if (!isLoading && !error) {
      redirectToDocumenso(destinationPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box className={styles.breadcrumbs} sx={{ mt: '-53px', mb: '32px' }}>
        <Link
          className={styles.documentViewText}
          to={backUrl + (activeTab ? `?activeTab=${activeTab}` : '')}
        >
          {t('buttons.back')}
        </Link>
      </Box>
      {isLoading ? (
        <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
          <Typography>Redirecting to Documenso...</Typography>
        </Box>
      ) : error ? (
        <Box display='flex' flexDirection='column' alignItems='center' gap={2} minHeight='200px'>
          <Typography color='error'>Error: {error}</Typography>
          <Button variant='contained' onClick={() => redirectToDocumenso(destinationPath)}>
            Retry
          </Button>
        </Box>
      ) : (
        <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
          <Typography>Redirecting to Documenso...</Typography>
        </Box>
      )}
    </>
  );
};

export default SigningPage;
